var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.7 108.4",
    style: {
      enableBackground: "new 0 0 228.7 108.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B3B3B3;}\r\n\t.st1{fill:#C2000B;}\r\n\t.st2{fill:#545051;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#991014;}\r\n\t.st5{opacity:0.25;}\r\n\t.st6{fill:url(#SVGID_1_);}\r\n\t.st7{fill:url(#SVGID_2_);}\r\n\t.st8{fill:url(#SVGID_3_);}\r\n\t.st9{fill:url(#SVGID_4_);}\r\n\t.st10{fill:url(#SVGID_5_);}\r\n\t.st11{fill:url(#SVGID_6_);}\r\n\t.st12{fill:url(#SVGID_7_);}\r\n\t.st13{fill:url(#SVGID_8_);}\r\n\t.st14{fill:url(#SVGID_9_);}\r\n\t.st15{fill:url(#SVGID_10_);}\r\n\t.st16{fill:url(#SVGID_11_);}\r\n\t.st17{fill:url(#SVGID_12_);}\r\n\t.st18{fill:url(#SVGID_13_);}\r\n\t.st19{fill:url(#SVGID_14_);}\r\n\t.st20{fill:#666666;}\r\n\t.st21{fill:#31977E;}\r\n\t.st22{fill:url(#SVGID_15_);}\r\n\t.st23{fill:url(#SVGID_16_);}\r\n\t.st24{fill:url(#SVGID_17_);}\r\n\t.st25{fill:url(#SVGID_18_);}\r\n\t.st26{fill:#199DBF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 26.9081,
    x2: 228.6681,
    y2: 26.9081,
    gradientTransform: "matrix(-1 0 0 -1 228.6681 108.4454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    style: {
      stopColor: "#F38430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5726,
    style: {
      stopColor: "#F9CB37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33A8C1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M228.5,96.8H34.4c-0.1,0-0.1,0.1-0.1,0.1v11.4c0,0.1-0.1,0.2-0.2,0.1L0,82.2C0,82.1,0,82,0,82l34.1-27.3 c0.1-0.1,0.2,0,0.2,0.1v10.4c0,0.1,0.1,0.1,0.1,0.1h194.1c0.1,0,0.1,0.1,0.1,0.1v31.3C228.7,96.8,228.6,96.8,228.5,96.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 81.5372,
    x2: 228.6681,
    y2: 81.5372,
    gradientTransform: "matrix(-1 0 0 -1 228.6681 108.4454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EA1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2877,
    style: {
      stopColor: "#F38430"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5726,
    style: {
      stopColor: "#F9CB37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#33A8C1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0.1,42.2h194.1c0.1,0,0.1,0.1,0.1,0.1v11.4c0,0.1,0.1,0.2,0.2,0.1l34.1-26.3c0.1,0,0.1-0.1,0-0.2L194.6,0 c-0.1-0.1-0.2,0-0.2,0.1v10.4c0,0.1-0.1,0.1-0.1,0.1H0.1c-0.1,0-0.1,0.1-0.1,0.1v31.3C0,42.2,0.1,42.2,0.1,42.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows2);
export default __webpack_public_path__ + "static/media/arrows2.e0699b045ff2d262a53b45b09edc493d.svg";
export { ForwardRef as ReactComponent };